import styled from 'styled-components';

export const panelStyles = { root: { padding: "400" } };

export const Container = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;